import { render, staticRenderFns } from "./PcButton.vue?vue&type=template&id=52ed753c&"
import script from "./PcButton.vue?vue&type=script&lang=js&"
export * from "./PcButton.vue?vue&type=script&lang=js&"
import style0 from "./PcButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports